import _getIterator from '/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-runtime/core-js/get-iterator';
import _regeneratorRuntime from '/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import API from '~/api/api.js';
import quHistory from '~/components/quotation-history.vue';
import chat from '~/components/chat.vue';
import task from '~/components/task-detail.vue';
import tab from '~/components/tab/tab.vue';
import tabs from '~/components/tab/tabs.vue';
import modal from '~/components/modal.vue';
import chatFull from '~/components/chat-full-box.vue';
import componentRelatedFile from '~/components/related-document-task.vue';
import upload from '~/components/upload.vue';
import isButton from '~/components/button.vue';
import updateCurrentEst from '~/components/EstCurrComponent';
import updateDeliveryDate from '~/components/DeliveryDateComponent';
var miniToastr = void 0;
if (process.browser) {
  miniToastr = require('mini-toastr');
}
var userData = '';

export default {
  middleware: ['auth', 'authorizeAdminAndEngineer'],
  mounted: function mounted() {
    miniToastr.init();
  },

  notifications: {
    showLoginError: {
      title: '',
      message: 'Hello from nuxt.js',
      type: 'error'
    },
    showSuccess: {
      title: 'Success',
      message: '',
      type: 'success'
    }
  },
  asyncData: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var store = _ref.store,
          params = _ref.params,
          error = _ref.error;
      var value1, messageResponse, personData, personInChat, messages;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              userData = store.state.authUser;
              _context.next = 3;
              return API.setToken(userData.tokenID);

            case 3:
              _context.next = 5;
              return API.getTaskDetail(params.id);

            case 5:
              value1 = _context.sent;

              if (!(value1.data.flag === false)) {
                _context.next = 8;
                break;
              }

              return _context.abrupt('return', error({
                statusCode: 401,
                message: value1.data.message
              }));

            case 8:
              _context.next = 10;
              return API.getMessage(params.id);

            case 10:
              messageResponse = _context.sent;
              _context.next = 13;
              return API.getPersonInProtTask(value1.data.datas.projectID, params.id);

            case 13:
              personData = _context.sent;
              personInChat = personData.data.datas;
              messages = messageResponse.data.datas;
              return _context.abrupt('return', {
                tokenData: userData,
                taskData: value1.data.datas,
                dataID: params.id,
                messages: messages,
                message: '',
                deliveryDate: '',
                personInChat: personInChat,
                openAcceptTask: false,
                openCancelTask: false,
                openCurrentEst: false,
                openCompleteTask: false,
                rejectMessage: ''
              });

            case 17:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function asyncData(_x) {
      return _ref2.apply(this, arguments);
    }

    return asyncData;
  }(),
  data: function data() {
    return {};
  },

  methods: {
    isAdmin: function isAdmin() {
      // console.log(this.$store.state.authUser.roleID)
      if (['User', 'SuperAdmin'].includes(this.$store.state.authUser.roleID)) {
        return true;
      }
      return false;
    },
    showModalCurrent: function showModalCurrent() {
      this.openCurrentEst = true;
    },

    rejectTask: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var btn, results;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return API.setToken(this.tokenData.tokenID);

              case 2:
                btn = this.$refs.btnReject;

                if (!(this.rejectMessage === '')) {
                  _context2.next = 7;
                  break;
                }

                this.showLoginError({
                  message: 'Please insert remark'
                });
                btn.enabled();
                return _context2.abrupt('return');

              case 7:
                _context2.next = 9;
                return API.rejectTask(this.taskData.projectID, this.taskData.prodTaskID, this.rejectMessage);

              case 9:
                results = _context2.sent;

                if (results.data.flag) {
                  this.showSuccess({
                    message: results.data.message
                  });
                  btn.enabled();
                  window.location.reload();
                } else {
                  this.showLoginError({
                    message: results.data.message
                  });
                  btn.enabled();
                }

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function rejectTask() {
        return _ref3.apply(this, arguments);
      }

      return rejectTask;
    }(),
    openCancelTaskModal: function openCancelTaskModal() {
      this.openCancelTask = true;
    },
    openCompleteTaskModal: function openCompleteTaskModal() {
      this.openCompleteTask = true;
    },
    uploadPO: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var items, formData, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, file, result;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return API.setToken(this.tokenData.tokenID);

              case 2:
                items = this.$refs.upload.getItems();
                formData = new FormData(); // Currently empty

                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context3.prev = 7;
                for (_iterator = _getIterator(items); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  file = _step.value;

                  formData.append('fileUpload', file.file, file.file.name);
                }
                _context3.next = 15;
                break;

              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3['catch'](7);
                _didIteratorError = true;
                _iteratorError = _context3.t0;

              case 15:
                _context3.prev = 15;
                _context3.prev = 16;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 18:
                _context3.prev = 18;

                if (!_didIteratorError) {
                  _context3.next = 21;
                  break;
                }

                throw _iteratorError;

              case 21:
                return _context3.finish(18);

              case 22:
                return _context3.finish(15);

              case 23:
                _context3.next = 25;
                return API.UploadPOMusubi(this.taskData.projectID, this.dataID, formData);

              case 25:
                result = _context3.sent;

                if (result.data.flag) {
                  this.showSuccess({
                    message: 'Alredy Upload PO'
                  });
                  window.location.reload();
                } else {
                  this.showLoginError({
                    message: result.data.message
                  });
                }

              case 27:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[7, 11, 15, 23], [16,, 18, 22]]);
      }));

      function uploadPO() {
        return _ref4.apply(this, arguments);
      }

      return uploadPO;
    }(),
    acceptTaskAction: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var button, result;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                button = this.$refs.btnConfirm;
                _context4.next = 3;
                return API.setToken(this.tokenData.tokenID);

              case 3:
                _context4.next = 5;
                return API.acceptTaskFromAdmin(this.taskData.projectID, this.currentTaskID);

              case 5:
                result = _context4.sent;


                button.enabled();

                if (result.data.flag) {
                  this.showSuccess({
                    message: result.data.message
                  });
                  window.location.reload();
                } else {
                  this.showLoginError({
                    message: result.data.message
                  });
                }

              case 8:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function acceptTaskAction() {
        return _ref5.apply(this, arguments);
      }

      return acceptTaskAction;
    }(),
    acceptComplete: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var button, result;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                button = this.$refs.btnConfirmComplete;
                _context5.next = 3;
                return API.setToken(this.tokenData.tokenID);

              case 3:
                _context5.next = 5;
                return API.completeTaskFromAdmin(this.taskData.prodTaskID);

              case 5:
                result = _context5.sent;

                button.enabled();
                if (result.data.flag) {
                  this.showSuccess({
                    message: result.data.message
                  });
                  window.location.reload();
                } else {
                  this.showLoginError({
                    message: result.data.message
                  });
                }

              case 8:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function acceptComplete() {
        return _ref6.apply(this, arguments);
      }

      return acceptComplete;
    }(),
    openAcceptTaskModal: function openAcceptTaskModal(taskID, event) {
      if (event) event.preventDefault();
      this.currentTaskID = taskID;
      this.openAcceptTask = true;
    }
  },
  components: {
    chat: chat,
    tabs: tabs,
    componentRelatedFile: componentRelatedFile,
    tab: tab,
    task: task,
    updateCurrentEst: updateCurrentEst,
    updateDeliveryDate: updateDeliveryDate,
    modal: modal,
    quHistory: quHistory,
    upload: upload,
    chatFull: chatFull,
    isButton: isButton
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/project/tasks/view/_id.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/project/tasks/view/_id.vue
// module chunks = 3